import React from "react";
import { useCustomTheme } from "../../contexts/CustomThemeContext";
import AppPhoneInput, {
  mapDialCodeToCountryCode,
  mapCountryCodeToDialCode,
} from "../../components/Shared/PhoneInput";

export type SupportedPhoneCountryCode = string;

type Props = {
  label?: string;
  countryCode: SupportedPhoneCountryCode;
  phoneNumber: string;
  onCountryCodeChange: (value: SupportedPhoneCountryCode) => void;
  onPhoneNumberChange: (value: string) => void;
  isRequired?: boolean;
  labelColor?: string;
  inputStyles?: Record<string, any>;
};

const WhatsAppPhoneInput: React.FC<Props> = ({
  label = "WhatsApp number",
  countryCode,
  phoneNumber,
  onCountryCodeChange,
  onPhoneNumberChange,
  isRequired,
  labelColor,
  inputStyles,
}) => {
  const { theme } = useCustomTheme();

  return (
    <AppPhoneInput
      label={label}
      value={phoneNumber}
      countryCode={mapDialCodeToCountryCode(countryCode)}
      placeholder="Enter WhatsApp number"
      onCountryChange={(value) => {
        onCountryCodeChange(mapCountryCodeToDialCode(value));
      }}
      onNumberChange={onPhoneNumberChange}
      theme={theme}
      isRequired={isRequired}
      labelColor={labelColor}
      inputStyles={inputStyles}
    />
  );
};

export default WhatsAppPhoneInput;